<template>
  <!-- new bar start-->
  <div id="sidebar" :class="{ 'nav-collapse': true }" v-if="hasSubMenu">
    <!-- sidebar menu start-->
    <div class="leftside-navigation sidebar">
      <el-menu :default-openeds="opened" >
        <!-- 一级 -->
        <div
          v-for="(item,indexFirst) in menu.child"
          :key="item.id"
        >
          <el-menu-item
            :class="{ selected: item.current == 1 }"
            :index="String(indexFirst + 1)"
            v-if='!item.child'
          >
            <template slot="title">
              <a :href="item.href" :style="'background:url('+icon(item.title)+' ) no-repeat;background-position: 22px center;background-size: 20px 20px;'">

                {{ getText(item.title) }}
              </a>
            </template>
          </el-menu-item>
          <el-submenu
            class="iconfont"
            :class="{ selected: item.current == 1 }"
            :index="String(indexFirst + 1)"
            v-if='item.child'
          >
            <template slot="title">
              <span :style="'background:url('+icon(item.title)+' ) no-repeat;background-position: 22px center;background-size: 20px 20px;'">{{ getText(item.title) }}</span>
            </template>
            <el-menu-item-group>
              <!-- 二级 -->
              <div
                v-for="(itemSecond, indexSecond) in item.child"
                :key="itemSecond.id"
              >
                <el-menu-item
                  :class="{ selected: itemSecond.current == 1 }"
                  :index="(indexFirst + 1) + '-' + (indexSecond + 1)"
                  v-if='!itemSecond.child'
                >
                  <template slot="title">
                    <a :href="itemSecond.href" >
                      {{ getText(itemSecond.title) }}
                    </a>
                  </template>
                </el-menu-item>
                <!-- 三级 -->
                <el-submenu v-if='itemSecond.child'
                            :index="(indexFirst + 1) + '-' + (indexSecond + 1)">
                  <template slot="title">
                    <!-- <el-tooltip class="item" effect="dark" :content="getText(itemSecond.title)" placement="right"> -->
                    <span style="padding-left: 42px !important;width:100px;width: 122px;overflow: hidden;text-overflow: ellipsis;">
                      {{ getText(itemSecond.title) }}
                    </span>
                    <!-- </el-tooltip> -->
                  </template>
                  <div
                    v-for="(itemThird, indexThird) in itemSecond.child"
                    :key="itemThird.id"
                  >
                    <el-menu-item
                      :class="{ selected: itemThird.current == 1 }"
                      :index="(indexFirst + 1) + '-'+(indexSecond + 1) +'-' + (indexThird + 1)"
                      v-if='!itemThird.child'
                    >
                      <template slot="title">
                        <a :href="itemThird.href" class="thirdStyle">
                          {{ getText(itemThird.title) }}
                        </a>
                      </template>
                    </el-menu-item>
                    <el-submenu
                      :index="(indexFirst + 1) + '-'+(indexSecond + 1) +'-' + (indexThird + 1)"
                      v-if='itemThird.child'
                    >
                      <template slot="title">
                        <span class="thirdStyle">{{ getText(itemThird.title) }}</span>
                      </template>
                      <el-menu-item
                        v-for="(itemFourth, indexFourth) in itemThird.child"
                        :class="{ selected: itemFourth.current == 1 }"
                        :key="itemFourth.id"
                        :index="(indexFirst + 1) + '-'+(indexSecond + 1) +'-' + (indexThird + 1) +'-'+(indexFourth + 1)"
                      >
                        <a :href="itemFourth.href">
                          {{ getText(itemFourth.title) }}
                        </a>
                      </el-menu-item>
                    </el-submenu>
                  </div>
                </el-submenu>
              </div>
            </el-menu-item-group>
          </el-submenu>

        </div>
      </el-menu>
    </div>
    <!-- sidebar menu end-->
  </div>
  <!-- new bar end-->
</template>
<style src="../../assets/css/fontFace.css"></style>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      opened: [],
      openIndex: 0
    };
  },
  methods: {
    getText(text) {
      return this.isInterviewSite ? this.$t(text) : text;
    },
    icon(title) {
      const info = {
        系统管理: 'system',
        数据管理: 'dataInfo',
        班级管理: 'class',
        课表管理: 'classlist',
        学员管理: 'student',
        教师管理: 'teacher',
        商品课程管理: 'goods',
        媒资管理: 'video',
      }[title];
      // eslint-disable-next-line
      return info && require(`@/assets/teaching/${info}.png`);
    },
    findOpened(menu, n, ind) {
      menu.child.forEach((item, index) => {
        if (n === 1) {
          this.openIndex++;
        }
        if (item.child) {
          this.findOpened(item, n + 1, index);
        } else if (item.current && n > 1) {
          let str = '';
          for (let i = 1; i < 2; i++) {
            str = `${this.openIndex}-${ind + 1}`;
          }
          this.opened = [`${this.openIndex}`, str];
        }
      });
    }
  },
  computed: {
    ...mapState(['menu']),
    hasSubMenu() {
      return this.menu.child && this.menu.child.length > 0;
    },
  },
  watch: {
    menu() {
      let n = 1;
      this.findOpened(this.menu, n, 0);
      n = 0;
      this.openIndex = 0;
    }
  },
};
</script>
<style>
.sidebar .el-menu-item a {
  display: block;
  /* padding: 0 0 0 40px; */
  color: #666;
}
.sidebar .selected a {
  background-color: #3368FA;
  color: #fff;
}
</style>
